const WhatsappIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-label="whatsapp-icon"
  >
    <path
      fill="white"
      fillRule="evenodd"
      d="M20.2 3.8C18 1.6 15.2.4 12 .4 5.6.4.6 5.6.6 11.8c0 2 .6 4 1.6 5.8l-1.6 6 6-1.6c1.6 1 3.6 1.4 5.4 1.4 6.4 0 11.4-5.2 11.4-11.4.2-3.2-1-6-3.2-8.2zM12 21.4c-1.8 0-3.4-.4-4.8-1.4l-.4-.2-3.6 1 1-3.6-.2-.4c-1-1.6-1.4-3.2-1.4-5 0-5.2 4.2-9.6 9.6-9.6 2.6 0 5 1 6.8 2.8 1.8 1.8 2.8 4.2 2.8 6.8-.2 5.4-4.6 9.6-9.8 9.6zm5.2-7.2c-.2-.2-1.6-.8-2-1-.2 0-.4-.2-.6.2-.2.4-.8 1-1 1.2-.2.2-.4.2-.6 0-.2-.2-1.2-.4-2.4-1.4-.8-.8-1.4-1.6-1.6-2-.2-.2 0-.4.2-.6.2-.2.2-.4.4-.6.4 0 .4 0 .4-.2v-.6c0-.2-.6-1.6-.8-2.2-.2-.6-.4-.4-.6-.4H8c-.2 0-.6 0-.8.4-.2.4-1 1-1 2.4s1 2.8 1.2 3c.2.2 2 3 4.8 4.4.6.2 1.2.4 1.6.6.6.2 1.4.2 1.8.2.6 0 1.6-.6 2-1.4.2-.6.2-1.2.2-1.4 0-.2-.2-.4-.6-.6z"
    />
  </svg>
);

export default WhatsappIcon;
